import { render, staticRenderFns } from "./SendInvoiceToCustomer.vue?vue&type=template&id=c8c12274&"
import script from "./SendInvoiceToCustomer.vue?vue&type=script&lang=js&"
export * from "./SendInvoiceToCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports